import userHeader from '@/components/userHeader.vue';
import { rankList } from './partten';
export default {
  components: {
    userHeader
  },
  data() {
    return {
      infoObj: {},
      dataFrom: {},
      treeData: [],
      rankList
    };
  },
  computed: {
    dataRule() {
      return {
        effectiveAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('生效日期')
        }],
        structureId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('变更职级')
        }]
      };
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          // let obj=this.dataFrom;
          // obj.customerId=this.infoObj.customerId;
          // obj.companyWorkerId=this.$route.params.id;
          // workersApply(obj).then(res=>{
          this.$message.success(this.$t('操作成功'));
          this.$router.go(-1);
          // });
        }
      });
    }
  }
};